export enum GithubPermissions {
  Administration = "administration",
  Checks = "checks",
  Statuses = "statuses",
  Contents = "contents",
  Deployments = "deployments",
  Issues = "issues",
  Members = "members",
  Metadata = "metadata",
  PullRequests = "pull_requests",
  Webhooks = "webhooks",
}
